import React, { useState,useRef } from "react";
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
  styled,
} from "@mui/material";

import { useLocation, useNavigate } from "react-router-dom";
import { cssProperties } from "../../utils/commonCssProperties";
import CetImage from '../../assets/images/Cet.png'
import PrintDownloadButton from "../../common/button/printDownloadButton";
import { useReactToPrint } from "react-to-print";
import { MdPrint } from "react-icons/md";
import { usePDF } from "react-to-pdf";
export default function PaymentReceipt() {
    // const navigate = useNavigate();
  const location = useLocation();
  const paymentRecord = JSON.parse(localStorage.getItem("paymentRecord"));
 const targetRef = useRef();
 const theme = useTheme();
  const handlePrint = useReactToPrint({
contentRef: targetRef,
  documentTitle: "Payment Receipt",
});
const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const style = styled({
    fontStyle: {
       fontSize: isMobile ? 18 : 20,
      fontWeight: 600,
      fontFamily:" Inter, sans-serif !important",
    },
  });
  const classes = style();

  const coursename = paymentRecord?.purpose;

  const displayText = coursename?.replace("Regisration for", "").trim();

  console.log(paymentRecord,"paymentrecordconspoeldddd")

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingBottom: 2,
          marginTop:4
        }}
      >
        <Typography pb={1} variant="h4">
          Payment Receipt
        </Typography>
      </Box>
      <Box
        sx={{
          maxWidth: 800,
          margin: "0 auto",
          minHeight: "50vh",
          backgroundColor: "#fff",
          borderRadius: "8px",
          paddingBottom: 2,
          border: `1px solid ${cssProperties.bordercolor.secondary3}`,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            padding: 2,
          }}
        >
          <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            <PrintDownloadButton
              name="Print Receipt"
              handleSubmit={handlePrint}
              startIcon={<MdPrint />}
            />
            {/* <PrintDownloadButton
              name="Download Receipt"
              handleSubmit={() => toPDF()}
              startIcon={<MdDownload />}
            /> */}
          </Box>
        </Box>
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "8px",
          }}
          id="receipt"
          ref={targetRef}
        >
          <Box sx={{ maxWidth: 800, margin: "0 auto" }}>
            <Grid
              container
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                padding: "25px 0",
                border: `5px solid ${cssProperties.bordercolor.primary}`,
                textAlign: "center",
              }}
            >
              <Grid
                item
                sm={12}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  component="img"
                  src={CetImage}
                  alt="CET Logo"
                  sx={{ width: 80, height: 80, marginBottom: 2 }} // size adjust kar sakte ho
                />
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 24 }}
                >
                  STATE COMMON ENTRANCE TEST CELL, MAHARASHTRA STATE
                </Typography>
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 500, fontSize: 16 }}
                >
                  8th Floor, New Excelsior Building, A.K.Nayak Marg, Fort,
                  Mumbai-400001. (M.S.)
                </Typography>
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 24 }}
                >
                Payment Receipt
                </Typography>
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 18 }}
                >
                  ({paymentRecord?.coursename})
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={{
                display: "flex",
                justifyContent: "center",

                padding: "25px 0",
                border: `5px solid ${cssProperties.bordercolor.primary}`,
              }}
              rowSpacing={1}
            >


              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "end",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 400, fontSize: 16 }}
                >
                  Name Of Payee
                </Typography>
              </Grid>
              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "start",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 16 }}
                >
                  {paymentRecord?.candidatename}
                </Typography>
              </Grid>

                            <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "end",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 400, fontSize: 16 }}
                >
                  Reference Number
                </Typography>
              </Grid>
              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "start",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 16 }}
                >
                  {paymentRecord?.referenceNo}
                </Typography>
              </Grid>


              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "end",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 400, fontSize: 16 }}
                >
                  Payee Id
                </Typography>
              </Grid>
              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "start",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 16 }}
                >
                  {paymentRecord?.applicantionid}
                </Typography>
              </Grid>

              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "end",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 400, fontSize: 16 }}
                >
                  Course
                </Typography>
              </Grid>
              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "start",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 16 }}
                >
                  {paymentRecord?.course_amount}
                </Typography>
              </Grid>
              {/* {paymentRecord?.noofcompexam && (<>
                <Grid
                  item
                  sm={6}
                  sx={{
                    display: "flex",

                    alignItems: "center",
                    padding: `0 5px`,
                    justifyContent: "end",
                  }}
                >
                  <Typography
                    sx={{ ...classes.fontStyle, fontWeight: 400, fontSize: 16 }}
                  >
                    Complimentary MockTest Amount
                  </Typography>
                </Grid>
                <Grid
                  item
                  sm={6}
                  sx={{
                    display: "flex",

                    alignItems: "center",
                    padding: `0 5px`,
                    justifyContent: "start",
                  }}
                >
                  <Typography
                    sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 16 }}
                  >
                    {paymentRecord?.compexamamount}
                  </Typography>
                </Grid>
              </>)} */}

              {Number(paymentRecord?.lateamount) > 0  && (
  <>
                <Grid
                  item
                  sm={6}
                  sx={{
                    display: "flex",

                    alignItems: "center",
                    padding: `0 5px`,
                    justifyContent: "end",
                  }}
                >
                  <Typography
                    sx={{ ...classes.fontStyle, fontWeight: 400, fontSize: 16 }}
                  >
                    Late Fee Amount
                  </Typography>
                </Grid>
                <Grid
                  item
                  sm={6}
                  sx={{
                    display: "flex",

                    alignItems: "center",
                    padding: `0 5px`,
                    justifyContent: "start",
                  }}
                >
                  <Typography
                    sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 16 }}
                  >
                    {(paymentRecord?.lateamount)?.toFixed(2)}
                  </Typography>
                </Grid>
              </>)}


{Number(paymentRecord?.optexamamount) > 0 && (
  <>
                <Grid
                  item
                  sm={6}
                  sx={{
                    display: "flex",

                    alignItems: "center",
                    padding: `0 5px`,
                    justifyContent: "end",
                  }}
                >
                  <Typography
                    sx={{ ...classes.fontStyle, fontWeight: 400, fontSize: 16 }}
                  >
                  Paid Mock Test (Incl. GST)
                  </Typography>
                </Grid>
                <Grid
                  item
                  sm={6}
                  sx={{
                    display: "flex",

                    alignItems: "center",
                    padding: `0 5px`,
                    justifyContent: "start",
                  }}
                >
                  <Typography
                    sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 16 }}
                  >
                    {/* {Number(paymentRecord?.optexamamount)} */}
                    {Number(paymentRecord?.optexamamount)?.toFixed(2)}
                  </Typography>
                </Grid>
              </>)}


                {Number(paymentRecord?.psychexamamount) > 0 && (
                <>
                <Grid
                  item
                  sm={6}
                  sx={{
                    display: "flex",

                    alignItems: "center",
                    padding: `0 5px`,
                    justifyContent: "end",
                  }}
                >
                  <Typography
                    sx={{ ...classes.fontStyle, fontWeight: 400, fontSize: 16 }}
                  >
                   Psychometric Test (Incl. GST)
                  </Typography>
                </Grid>
                <Grid
                  item
                  sm={6}
                  sx={{
                    display: "flex",

                    alignItems: "center",
                    padding: `0 5px`,
                    justifyContent: "start",
                  }}
                >
                  <Typography
                    sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 16 }}
                  >
                    {Number(paymentRecord?.psychexamamount)?.toFixed(2)}
                  </Typography>
                </Grid>
              </>)}
              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "end",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 400, fontSize: 16 }}
                >
                  Total Amount
                </Typography>
              </Grid>
              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "start",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 16 }}
                >
                  {paymentRecord?.totalFee}
                </Typography>
              </Grid>

              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "end",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 400, fontSize: 16 }}
                >
                  Payment Initiation Date
                </Typography>
              </Grid>
              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "start",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 16 }}
                >
                  {paymentRecord?.paymentInitiatedOn}
                </Typography>
              </Grid>

              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "end",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 400, fontSize: 16 }}
                >
                  Payment Status
                </Typography>
              </Grid>
              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "start",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 16 }}
                >
                  {paymentRecord?.paymentStatus}
                </Typography>
              </Grid>
              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "end",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 400, fontSize: 16 }}
                >
                  Payment Completion Date
                </Typography>
              </Grid>
              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "start",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 16 }}
                >
                  {paymentRecord?.paymentcompletiondate}
                </Typography>
              </Grid>
              {/* <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "end",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 400, fontSize: 16 }}
                >
                  Mode Of Payment
                </Typography>
              </Grid>
              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "start",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 16 }}
                >
                  {paymentRecord?.gatewaycourseid == 1
                    ? "Billdesk"
                    : paymentRecord?.gatewaycourseid == 2
                      ? "PayU"
                      : paymentRecord?.gatewaycourseid == 3
                        ? "AirPay" : ""}
                </Typography>
              </Grid> */}

              {/* <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "end",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 400, fontSize: 16 }}
                >
                  Purpose
                </Typography>
              </Grid>
              <Grid
                item
                sm={6}
                sx={{
                  display: "flex",

                  alignItems: "center",
                  padding: `0 5px`,
                  justifyContent: "start",
                }}
              >
                <Typography
                  sx={{ ...classes.fontStyle, fontWeight: 600, fontSize: 16 }}
                >
                  {paymentRecord.paymenttext} - {paymentRecord?.coursename?.trim()}
                </Typography>
              </Grid> */}
            </Grid>
          </Box>
        </div>
      </Box>
    </Box>
  );
}
